import React, { useState } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup' // Import Yup if you need validation
import Signup from './auth/singup' // Ensure the path is correct
import Gender from './gender/gender'
import Region from './region/region'
import Traits from './traits/taits'
import VocieList from './voice-list/voice-list'
import Method from './method/method'
import Bio from './bio/bio'
import BioStep2 from './bio2/bio2'
import Faq from './faq/faq'
import Layout from './Layout'

export default function Step() {
  const [currentStep, setCurrentStep] = useState(0)

  // Define the initial values for your form
  const initialValues = {
    userData: {},
    gender: 'Female',
    region: 'South America',
    traits: 'Outgoing',
    method: 'Web',
    voiceId: '',
    avatarId: 'default',
    avatarPreview: '/images/default-removebg.png',
    bio: {
      operationalHours: {
        monday: { from: '08:00', to: '17:00', open: true },
        tuesday: { from: '08:00', to: '17:00', open: true },
        wednesday: { from: '08:00', to: '17:00', open: true },
        thursday: { from: '08:00', to: '17:00', open: true },
        friday: { from: '08:00', to: '17:00', open: true },
        saturday: { from: '08:00', to: '17:00', open: false },
        sunday: { from: '08:00', to: '17:00', open: false },
      },
    },
    faq: [],
  }

  // Optional validation schema using Yup
  // const validationSchema = Yup.object({})
  const validationSchema = Yup.object().shape({
    userData: Yup.object().shape({
      firstName: Yup.string().required('First name is required'),
      lastName: Yup.string().required('Last name is required'),
      email: Yup.string().email('Invalid email').required('Email is required'),
      telephone: Yup.string()
        .matches(/^\d+$/, 'Telephone must be a number')
        .required('Telephone is required'),
    }),
    gender: Yup.string().required('Gender is required'),
    region: Yup.string().required('Region is required'),
    traits: Yup.string().required('Traits are required'),
    method: Yup.string().required('Method is required'),
    avatarId: Yup.string().required('Avatar ID is required'),
    avatarPreview: Yup.string().required('Avatar preview is required'),
    // bio: Yup.object().shape({
    //   language: Yup.string().required('Language is required'),
    //   operationalHours: Yup.object().shape({
    //     monday: Yup.object().shape({
    //       from: Yup.string().required('Required'),
    //       to: Yup.string().required('Required'),
    //       open: Yup.boolean().required('Required')
    //     }),
    //     tuesday: Yup.object().shape({
    //       from: Yup.string().required('Required'),
    //       to: Yup.string().required('Required'),
    //       open: Yup.boolean().required('Required')
    //     }),
    //     wednesday: Yup.object().shape({
    //       from: Yup.string().required('Required'),
    //       to: Yup.string().required('Required'),
    //       open: Yup.boolean().required('Required')
    //     }),
    //     thursday: Yup.object().shape({
    //       from: Yup.string().required('Required'),
    //       to: Yup.string().required('Required'),
    //       open: Yup.boolean().required('Required')
    //     }),
    //     friday: Yup.object().shape({
    //       from: Yup.string().required('Required'),
    //       to: Yup.string().required('Required'),
    //       open: Yup.boolean().required('Required')
    //     }),
    //     saturday: Yup.object().shape({
    //       from: Yup.string().required('Required'),
    //       to: Yup.string().required('Required'),
    //       open: Yup.boolean().required('Required')
    //     }),
    //     sunday: Yup.object().shape({
    //       from: Yup.string().required('Required'),
    //       to: Yup.string().required('Required'),
    //       open: Yup.boolean().required('Required')
    //     }),
    //   })
    // }),
  })

  const updateLocalValues = (values) => {
    const agent = JSON.parse(localStorage.getItem('agent'))
    localStorage.setItem('agent', JSON.stringify(values))
    // if (values.avatarId !== agent.avatarId) {
    //   console.log('avatarId changed')
    //   startSession()
    // }
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        console.log('Form Submitted:', values)
      }}
    >
      {({ values }) => {
        updateLocalValues(values)
        return (
          <div>
            {console.log('values', values)}
            {currentStep === 0 ? (
              <Signup
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
              />
            ) : currentStep === 1 ? (
              <Layout>
                <Method
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                />
              </Layout>
            ) : currentStep === 2 ? (
              <Layout>
                <Gender
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                />
              </Layout>
            ) : currentStep === 3 ? (
              <Layout>
                <Region
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                />
              </Layout>
            ) : currentStep === 4 ? (
              <Layout>
                <Traits
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                />
              </Layout>
            ) : currentStep === 5 ? (
              <Layout>
                <VocieList
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                />
              </Layout>
            ) : currentStep === 6 ? (
              <Layout>
                <Bio
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                />
              </Layout>
            ) : currentStep === 7 ? (
              <Layout>
                <BioStep2
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                />
              </Layout>
            ) : currentStep === 8 ? (
              <Layout>
                <Faq
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                />
              </Layout>
            ) : (
              ''
            )}
          </div>
        )
      }}
    </Formik>
  )
}
